export default __webpack_public_path__ + "static/media/oak.478b2c52.jpg";